import type { MouseEventHandler } from 'react';
import EmptyState from './EmptyState';

type RetryCardProps = {
  title?: string;
  description?: string;
  onRetry?: MouseEventHandler<HTMLButtonElement>;
};

export default function RetryCard({ title = 'Something went wrong', description, onRetry }: RetryCardProps) {
  return (
    <EmptyState
      title={title}
      description={description}
      action={onRetry ? (
        <button className="btn btn-outline" onClick={onRetry}>Retry</button>
      ) : null}
    />
  );
}
